import React from 'react';
import firebase from '../../firebase';
import { Grid, Form, Header, Button, Message, Segment, Image } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import logo from '../../assets/pulse_logo.png'

class Login extends React.Component {

  state = {
    email: "",
    password: "",
		errors: [],
    loading: false
	};
		
	displayErrors = errors => 
		errors.map( (error, i) => <p key={i}> {error.message} </p> );

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleSubmit = event => {
    event.preventDefault();
    //Check if email & password is empty
    if (this.isFormValid(this.state)) {
      this.setState({ errors: [], loading: true });
      //login with firebase
      firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password)
        .then(signedInUser => {
          console.log(signedInUser);
        })
        .catch(err => {
          console.error(err);
          this.setState({
            errors: this.state.errors.concat(err),
            loading: false
          });
        });
    }
  };

	isFormValid = ({ email, password }) => email && password;

	handleInputError = (errors, inputName) => {
		return errors.some(error => error.message.toLowerCase().includes(inputName)) ? 'error' : '' 
	}

  render() {
    const { email, password, errors, loading } = this.state;

    return (
      <Grid textAlign="center" verticalAlign="middle" className="main">
        <Grid.Column style={{ maxWidth: 500 }}>
          <Header inverted as="h1" textAlign="center" color='teal'>
              PULSE
          </Header>
          <Header inverted as="h4" textAlign="center" color='teal'>
            A ChatApp For Developers 
          </Header>
          <Image src={logo} centered size='medium'/>
          <Header inverted as="h1" textAlign="center" color='teal'>
            LOGIN
          </Header>
          <Form inverted onSubmit={this.handleSubmit} size="large">
            <Segment stacked inverted>
              <Form.Input fluid name="email" icon="mail" iconPosition="left" placeholder="Email Address"
                onChange={this.handleChange} value={email} 
								className={this.handleInputError(errors, 'email')} type="email" />
              <Form.Input fluid name="password" icon="lock" iconPosition="left" placeholder="Password"
  							onChange={this.handleChange} value={password} 
								className={this.handleInputError(errors, 'password')} type="password" />
              <Button disabled={loading} className={loading ? 'loading' : ''} fluid size="large">
                Login
              </Button>
            </Segment>
          </Form>
					{errors.length > 0 && (
						<Message error>
							<h3>Error!</h3>
							{this.displayErrors(errors)}
						</Message>
					)}
          <Message>
            Don't have an account? <Link to="/signup"> Sign Up </Link>
          </Message>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Login;